import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';

class MetasploitAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'metasploit';
	addHostWorkspace(host){
		let request = {
			url: [this.getAPIUrl(), 'hosts'].join('/'),
			data: host
		};
		return httpClient.postAsync(request);
	}
}

export default new MetasploitAPI();
